import { mapQuerystringToSearchModel, mapSearchModelToSearchServiceModel, mapSearchServiceModelToSearchModel, } from '@aviv-search/transformers';
import { getDefaultModel } from '@search/core/helpers/getDefaultModel';
import { ORDER_PARAM, PAGE_PARAM } from '@search/core/helpers/getQueryString';
import { isEmpty, toNumber } from 'lodash';
import { SEO_PATH_PARAM } from '../../hooks/useRouter/useRouter';
import { fetchSeoProps } from '../../services/seoProps/fetchSeoProps';
import { applySearchModelFallback } from '../applyModelFallback';
import { filterSeoQueryStringParams } from '../filterSeoQueryStringParams';
const getSeoRouterProps = (seoProps, defaultOrder, defaultPlaceId) => {
    if ('gone' in seoProps && seoProps.gone) {
        return { gone: true };
    }
    if ('permanentRedirect' in seoProps && seoProps.permanentRedirect) {
        return { permanentRedirect: seoProps.permanentRedirect };
    }
    if ('seoModel' in seoProps && 'page' in seoProps && 'order' in seoProps) {
        const { seoModel, page, order } = seoProps;
        const searchModel = applySearchModelFallback(mapSearchServiceModelToSearchModel(seoModel));
        const searchServiceModel = mapSearchModelToSearchServiceModel(searchModel);
        return {
            searchModel,
            searchServiceModel,
            seoModel,
            page: page ?? 1,
            order: order ?? defaultOrder,
        };
    }
    // fallback
    const defaultSearchModel = getDefaultModel(defaultPlaceId);
    const searchServiceModel = mapSearchModelToSearchServiceModel(defaultSearchModel);
    return {
        searchModel: defaultSearchModel,
        searchServiceModel,
        seoModel: undefined,
        page: 1,
        order: defaultOrder,
    };
};
const getTechnicalRouterProps = ({ queryString, pageParam, orderParam, defaultOrder, defaultPlaceId, }) => {
    const searchModel = (!isEmpty(queryString) ? mapQuerystringToSearchModel(queryString) : undefined) ?? getDefaultModel(defaultPlaceId);
    return {
        searchModel,
        searchServiceModel: mapSearchModelToSearchServiceModel(searchModel),
        page: toNumber(pageParam) > 0 ? toNumber(pageParam) : 1,
        order: orderParam ?? defaultOrder,
    };
};
const getParams = (searchParams) => ({
    queryString: decodeURIComponent(searchParams.toString()),
    pageParam: searchParams.get(PAGE_PARAM),
    orderParam: searchParams.get(ORDER_PARAM),
});
export const getRouterProps = async ({ searchParams, language, bffUri, defaultOrder, defaultPlaceId, }) => {
    const seoParam = searchParams.get(SEO_PATH_PARAM);
    const seoQueryString = searchParams.get('seoQueryString') ?? '';
    const filteredSeoQueryString = filterSeoQueryStringParams(seoQueryString);
    const seoReconstructedLink = `${seoParam}${filteredSeoQueryString ? '?' : ''}${filteredSeoQueryString}`;
    return seoParam
        ? getSeoRouterProps(await fetchSeoProps(seoReconstructedLink, language, bffUri), defaultOrder, defaultPlaceId)
        : getTechnicalRouterProps({ ...getParams(searchParams), defaultOrder, defaultPlaceId });
};
